"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const rx_socketio_1 = require("@soluto-private/rx-socketio");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const io = require("socket.io-client");
const types_1 = require("../../../src/types");
__exportStar(require("../../../src/types"), exports);
const messageEvents = [types_1.SocketEvents.MessageSubscribe, types_1.SocketEvents.MessageUpdates, types_1.SocketEvents.RoomUpdates];
exports.create = ({ url, clientApi, clientVersion, apiKey, accessTokenProvider, id, }) => {
    const { messages$, connectionStatus$, emit$, socketEvents$ } = rx_socketio_1.default(rxjs_1.defer(() => {
        const provider = accessTokenProvider();
        return typeof provider === 'string' ? [provider] : provider;
    }).pipe(operators_1.map((accessToken) => io(url, {
        query: { clientApi, clientVersion, accessToken, apiKey, id },
        transports: ['websocket'],
        timeout: 30000,
    }))), messageEvents);
    const sendSubscribeToRoom$ = (roomId) => rxjs_1.combineLatest([emit$, connectionStatus$]).pipe(operators_1.mergeMap(([emit, connection]) => {
        if (!connection.status)
            return rxjs_1.EMPTY;
        return emit({
            event: types_1.SocketEvents.MessageSubscribe,
            payload: { roomId },
        });
    }), operators_1.ignoreElements());
    const serverEventsStreamMap = {};
    const requestSnapshotOnRoom = (roomId, limit) => emit$
        .pipe(operators_1.mergeMap((emit) => emit({
        event: types_1.SocketEvents.RoomSnapshot,
        payload: { roomId, limit },
    })), operators_1.take(1))
        .toPromise();
    const roomUpdates = (roomId) => {
        if (!serverEventsStreamMap[roomId]) {
            serverEventsStreamMap[roomId] = rxjs_1.merge(sendSubscribeToRoom$(roomId), messages$.pipe(operators_1.filter(({ event }) => messageEvents.some((e) => e === event)), operators_1.map(({ payload }) => payload))).pipe(operators_1.filter((update) => update.roomId === roomId), operators_1.finalize(async () => {
                await emit$
                    .pipe(operators_1.mergeMap((emit) => emit({
                    event: types_1.SocketEvents.MessageUnsubscribe,
                    payload: { roomId },
                })), operators_1.take(1))
                    .toPromise();
                delete serverEventsStreamMap[roomId];
            }), operators_1.publishReplay(1), operators_1.refCount());
        }
        return serverEventsStreamMap[roomId];
    };
    return {
        connectionStatus$,
        requestSnapshotOnRoom,
        roomUpdates,
        socketEvents$,
    };
};
